/**
 * ⛔ `s1027` G-27: ПОВТОР ЗАПРОСА — ТОЛЬКО СБОЮ СВЯЗИ И СЕРВЕРА. 401/403/404/419/422 —
 * ответ по существу («не вошли», «нет права», «нет такой», «так нельзя»): повтор
 * его не изменит, а экран лишнюю секунду висит в загрузке.
 */
const OTVET_PO_SUSHCHESTVU = [401, 403, 404, 419, 422];

export function povtorZaprosa(failureCount: number, error: unknown): boolean {
  const status = (error as { response?: { status?: number } } | null)?.response?.status;

  return failureCount < 1 && !(status !== undefined && OTVET_PO_SUSHCHESTVU.includes(status));
}
